import Vue from 'vue'

import avatar from '@/components/Avatar/avatar.vue'
import infoBlock from '@/components/InfoBlock/InfoBlock.vue'
import UiTransition from '@/components/Ui/Transition/Transition.vue'
import ActiveTable from '@/components/Ui/ActiveTable/ActiveTable.vue'
import PageTitle from '@/components/PageTitle/pageTitle.vue'

import UiButton from '@/components/Ui/Button/Button.vue'
import InlineIcons from '@/components/Ui/Icon/InlineIcon.vue'
import ActiveForm from '@/components/Ui/ActiveForm/ActiveForm.vue'
import ActiveField from '@/components/Ui/ActiveForm/ActiveField.vue'
import Scrollbar from '@/components/Ui/Scrollbar/Scrollbar.vue'
import UiTabs from '@/components/Ui/Tabs/Tabs.vue'
import FormField from '@/components/Ui/FormField/FormField.vue'

const GlobalComponents = {
  install () {
    Vue.component(PageTitle.name, PageTitle)
    Vue.component(avatar.name, avatar)
    Vue.component(infoBlock.name, infoBlock)

    Vue.component('v-style', {
      // @ts-ignore
      render: function (createElement) {
        return createElement('style', this.$slots.default)
      }
    });

    Vue.component('ui-transition', UiTransition)
    Vue.component('ui-button', UiButton)

    Vue.component('ui-inline-icon', InlineIcons)

    Vue.component('active-form', ActiveForm)
    Vue.component('active-field', ActiveField)
    Vue.component('ui-scrollbar', Scrollbar)

    Vue.component('active-table', ActiveTable)

    Vue.component('ui-tabs', UiTabs)

    Vue.component('UiFormField', FormField)
  }
}

export default GlobalComponents